export const IS_HEADER_JAZZ = "isHeaderJazz";
export const USER_COUNTRY = "userCountry";
export const EVENT_BANNERS_CLOSED = "eventBannerClosed";
export const SHOW_OFFER_MODAL = "showOfferModal";
export const FREETV_REDIRECT = "freeTvRedirect";
export const FROM_WELCOME = "fromWelcome";
export const TOUR_HEART_CLICKED = "tourHeartClicked";
export const TOUR_FINAL_STEP_REACHED = "tourFinalStepReached";
